export const PageView = {
  Init: 'ready',
  Loader: 'preloader',
  LeadLoader: 'leadLoader',
  ShowLocation: 'showLocation',
  ErrorPopUp: 'error-popup',
  MobileError: 'error',
  Lead: 'lead',
  Completed: 'completed',
  LeadCompleted: 'LeadCompleted',
};
export const ErrorView = {
  ValidationGuid: 88,
  SaveDB: 89,
  Desktop: 90,
  GUID: 91,
  General: 92,
};
